import { apiSlice } from "../../api/apiSlice";

export const ADMIN_ACTIVITY_LOG_PAGE_SIZE = 50;

const toCsvParam = (value) => {
  if (Array.isArray(value)) {
    const cleaned = value.map((v) => String(v).trim()).filter(Boolean);
    return cleaned.length ? cleaned.join(",") : undefined;
  }
  if (value == null || value === "") return undefined;
  return String(value);
};

export const adminActivityLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminActivityLogs: builder.query({
      query: ({
        sortBy,
        type,
        query,
        startDate,
        endDate,
        action,
        entityType,
        companyId,
        page,
        limit,
      }) => {
        const params = new URLSearchParams();
        if (sortBy) params.set("sort_by", sortBy);
        if (type) params.set("type", type);
        if (query) params.set("query", query);
        if (startDate) params.set("startDate", startDate);
        if (endDate) params.set("endDate", endDate);
        const actionParam = toCsvParam(action);
        if (actionParam) params.set("action", actionParam);
        const entityTypeParam = toCsvParam(entityType);
        if (entityTypeParam) params.set("entityType", entityTypeParam);
        if (companyId) params.set("companyId", companyId);
        params.set("page", String(page ?? 1));
        params.set("limit", String(limit ?? ADMIN_ACTIVITY_LOG_PAGE_SIZE));
        return {
          url: `/api/admin-activity-logs?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getAdminActivityLogById: builder.query({
      query: (id) => ({
        url: `/api/admin-activity-logs/${id}`,
        method: "GET",
      }),
    }),
    getAdminActivityLogMeta: builder.query({
      query: () => ({
        url: `/api/admin-activity-logs/meta`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAdminActivityLogsQuery,
  useLazyGetAdminActivityLogsQuery,
  useGetAdminActivityLogByIdQuery,
  useLazyGetAdminActivityLogByIdQuery,
  useGetAdminActivityLogMetaQuery,
} = adminActivityLogApiSlice;
